import { FC } from "react";

import { Stack } from "@mui/material";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import {
  DashboardDialog,
  DashboardDialogBody,
  DashboardDialogContent,
  DashboardDialogFooter,
  DashboardDialogHeader,
} from "@/dashboard-design-system/DashboardDialog";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

export interface SmsOptInConfirmModalProps {
  open: boolean;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
}

export const SmsOptInConfirmModal: FC<SmsOptInConfirmModalProps> = ({ open, onConfirm, onCancel }) => {
  const { t } = useTranslate();

  return (
    <DashboardDialog open={open} onClose={onCancel} maxWidth="sm">
      <DashboardDialogBody
        slots={{
          header: <DashboardDialogHeader title={t("dashboard", "ticketing.automatedCommunications.smsOptIn.title")} />,
          content: (
            <DashboardDialogContent>
              <DashboardTypography variant="body1" vibe="text-neutral-moderate">
                {t("dashboard", "ticketing.automatedCommunications.smsOptIn.body")}
              </DashboardTypography>
            </DashboardDialogContent>
          ),
          footer: (
            <DashboardDialogFooter>
              <Stack direction="row" gap={1} justifyContent="flex-end" sx={{ width: "100%" }}>
                <DashboardButton variant="outlined" onClick={onCancel}>
                  {t("dashboard", "ticketing.automatedCommunications.smsOptIn.cancel")}
                </DashboardButton>
                <DashboardButton variant="filled" onClick={() => void onConfirm()}>
                  {t("dashboard", "ticketing.automatedCommunications.smsOptIn.confirm")}
                </DashboardButton>
              </Stack>
            </DashboardDialogFooter>
          ),
        }}
      />
    </DashboardDialog>
  );
};
